/* Foberry lux2 — (1) desktop product gallery: big first image + the rest in a 2-up swiper, glass arrows inside the photos, (2) scroll colour-fill headings (off in the theme editor, reduced motion, touch phones and the hero). */
(function () {
  var d = document, W = window;
  var mq = W.matchMedia ? W.matchMedia('(min-width: 769px)') : { matches: true };

  function initGallery(g) {
    if (g.__fbg) return;
    var ul = g.querySelector('.media-gallery__grid');
    if (!ul || ul.children.length < 4) return;
    g.__fbg = 1;
    var prev = d.createElement('button'), next = d.createElement('button');
    prev.type = next.type = 'button';
    prev.className = 'fbg-nav fbg-nav--prev'; next.className = 'fbg-nav fbg-nav--next';
    prev.setAttribute('aria-label', 'Previous photos'); next.setAttribute('aria-label', 'Next photos');
    prev.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';
    next.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
    g.appendChild(prev); g.appendChild(next);
    function step() { var s = ul.children[1]; return s ? s.getBoundingClientRect().width + 10 : 300; }
    prev.addEventListener('click', function () { ul.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { ul.scrollBy({ left: step(), behavior: 'smooth' }); });
    function place() {
      var on = mq.matches;
      prev.hidden = next.hidden = !on;
      if (!on) return;
      var a = ul.children[0], b = ul.children[1];
      if (!a || !b) return;
      var gr = g.getBoundingClientRect(), ur = ul.getBoundingClientRect();
      var inset = 14;
      var top = (ur.top - gr.top) + a.offsetHeight + 10 + b.offsetHeight / 2 - 22;
      prev.style.top = next.style.top = Math.max(0, top) + 'px';
      prev.style.left = ((ur.left - gr.left) + inset) + 'px';
      next.style.left = ((ur.right - gr.left) - inset - 44) + 'px';
      next.style.right = 'auto';
      prev.disabled = ul.scrollLeft < 4;
      next.disabled = ul.scrollLeft + ul.clientWidth >= ul.scrollWidth - 4;
    }
    ul.addEventListener('scroll', place, { passive: true });
    W.addEventListener('resize', place, { passive: true });
    W.addEventListener('load', place);
    if ('ResizeObserver' in W) { var ro = new ResizeObserver(place); ro.observe(ul); ro.observe(g); }
    place();
  }
  function galleries(root) {
    [].forEach.call((root || d).querySelectorAll('media-gallery.media-gallery--large-first-image'), initGallery);
  }
  function ready(f) { d.readyState === 'loading' ? d.addEventListener('DOMContentLoaded', f) : f(); }
  ready(function () { galleries(); });
  d.addEventListener('shopify:section:load', function (e) { galleries(e.target); });
})();

(function () {
  if (window.__fbLux2) return; window.__fbLux2 = 1;
  var d = document, W = window;
  function ready(f) { d.readyState === 'loading' ? d.addEventListener('DOMContentLoaded', f) : f(); }

  ready(function () {
    if ((W.Shopify && W.Shopify.designMode) || (W.matchMedia && (W.matchMedia('(prefers-reduced-motion: reduce)').matches || W.matchMedia('(hover: none) and (pointer: coarse)').matches))) return;

    var AUTO = '#MainContent h1, #MainContent h2, #MainContent .text-block.h1 > *, #MainContent .text-block.h2 > *, #MainContent .text-block.h3 > *';
    var SKIP = '.product-details, .product-card, .cart-items, #fullscreen-modal, .fb-nofill, [data-fb-nofill], header, footer, .shopify-block product-card, .hero, .hero-wrapper, .fbfab';
    var list = [];

    function collect(root) {
      var nodes = (root || d).querySelectorAll('.fb-fill, ' + AUTO);
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.__fbF) continue;
        if (el.closest('.hero, .hero-wrapper, .fbfab, .fb-nofill, [data-fb-nofill]')) continue;
        if (!el.classList.contains('fb-fill') && el.closest(SKIP)) continue;
        if (!el.textContent.trim()) continue;
        el.__fbF = 1;
        el.classList.add('fb-fill');
        list.push({ el: el, on: false });
      }
    }

    function prep(item) {
      var el = item.el, cs = getComputedStyle(el);
      var col = cs.color;
      if (!col || col === 'rgba(0, 0, 0, 0)' || col === 'transparent') col = cs.webkitTextFillColor || '#0b0b0d';
      el.style.setProperty('--fb-fc', col);
      var lh = parseFloat(cs.lineHeight) || parseFloat(cs.fontSize) * 1.2;
      el.style.setProperty('--fb-fill-dir', el.getBoundingClientRect().height > lh * 1.7 ? '180deg' : '90deg');
      el.classList.add('fb-fill-on');
      item.ready = true;
    }

    var vh = W.innerHeight, ticking = false, io;
    function frame() {
      ticking = false;
      for (var i = 0; i < list.length; i++) {
        var it = list[i];
        if (!it.on) continue;
        if (!it.ready) prep(it);
        var r = it.el.getBoundingClientRect();
        var start = vh * 0.92, end = vh * 0.38;
        var p = (start - r.top) / Math.max(1, (start - end) + r.height * 0.25);
        p = p < 0 ? 0 : p > 1 ? 1 : p;
        it.el.style.setProperty('--p', (p * 100).toFixed(1) + '%');
      }
    }
    function req() { if (!ticking) { ticking = true; W.requestAnimationFrame(frame); } }

    function observeAll() {
      if (!('IntersectionObserver' in W)) { list.forEach(function (it) { it.on = true; }); req(); return; }
      if (!io) {
        io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            for (var i = 0; i < list.length; i++) if (list[i].el === e.target) { list[i].on = e.isIntersecting; break; }
          });
          req();
        }, { rootMargin: '10% 0px 10% 0px' });
      }
      list.forEach(function (it) { if (!it.obs) { it.obs = 1; io.observe(it.el); } });
    }

    collect(); observeAll(); req();
    W.addEventListener('scroll', req, { passive: true });
    W.addEventListener('resize', function () { vh = W.innerHeight; list.forEach(function (it) { it.ready = false; }); req(); }, { passive: true });
  });
})();